angular.module("app").controller("EditLoyaltyController", [
    '$scope',
    '$timeout',
    'loyaltyService',
    'logger',
    'errorHandler',
    'preloadedPointData',
    'preloadedImages',
    'deepCompare',
    '$stateParams',
    'settingsService',
    '$cookies',
    '$uibModalInstance',
    'lang',
    'Utils',
    function ($scope,
              $timeout,
              loyaltyService,
              logger,
              errorHandler,
              preloadedPointData,
              preloadedImages,
              deepCompare,
              $stateParams,
              settingsService,
              $cookies,
              $modalInstance,
              lang,
              Utils) {

        var settings =  settingsService.getSettings();

        (init = function (data) {
            $scope.pointData = angular.copy(data);
            $scope.pointData.lang = lang;
            $scope.defaultImages = preloadedImages;
            $scope.state = {};
        })(preloadedPointData);

        $scope.languages = settings.skin.languages;


        $scope.submitEditProductForm = function (event) {
            event.preventDefault();

            $scope.state.isSavePressed = true;

            if (!$scope.pointData.src || !$scope.pointData.display_name) {
                return;
            }

            var changes = deepCompare.getChanges(angular.copy(preloadedPointData), $scope.pointData);

            if (!changes) {
                logger.logError("global.no_changes");
                return;
            }

            var makeRequest = function (data, result) {
                if (result){
                    changes.src = result;
                }
                var requestObj = {
                    point: angular.copy(changes)
                };
                requestObj.point.lang = $scope.pointData.lang;
                requestObj.point.id = $scope.pointData.id;

                loyaltyService.changeLevel(requestObj).then(
                    function (response) {
                        if (response.status === "ok") {
                            logger.logSuccess("global.saved");
                            $modalInstance.close();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                )
            }
            if (changes.src && changes.src.indexOf("data:image") === -1){
                Utils.getBlob(changes.src, makeRequest);
            } else {
                makeRequest();
            }



        };

        $scope.getDisplayName = function getDisplayName(language) {
            if (preloadedPointData.display_name !== $scope.pointData.display_name){
                logger.logWarning("You have unsaved display name")
            }
            loyaltyService.getLevels(language, $scope.pointData.id).then(
                function (response) {
                    if (response.status === "ok") {
                        var displayName = response.points.length && response.points[0].display_name;
                        $scope.pointData.display_name = displayName;
                        preloadedPointData.display_name = displayName;
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }

]);